import ErrorBoundary from "@client/controls/ErrorBoundary/component";
import { useOnNavigate } from "@client/hooks/navigation";
import { type GenericMap } from "@client/types";
import { type WithChildren } from "@client/types/WithChildren";
import { parseQueryString } from "@common/lib/url";
import * as React from "react";
import { Route, Routes } from "react-router-dom";

export type LoadPage = (path: string, qs: GenericMap<any>) => void;

type UrlTrackerProps = {
  loadPage: LoadPage;
};
const UrlTracker = (props: UrlTrackerProps) => {
  useOnNavigate((location) => {
    props.loadPage(location.pathname, parseQueryString(location.search));
  });

  return null;
};

export interface MapProps {
  isLoading: boolean;
  hideError: boolean;
  homePageId: string;
  children?: any;
}

export interface ActionProps {
  loadPage: LoadPage;
}

type SpaContainerProps = WithChildren & {
  homePageId: string;
  loadPage: LoadPage;
};
const SpaContainer = (props: SpaContainerProps) => (
  <>
    {props.children}

    <Routes>
      <Route path="*" element={<UrlTracker loadPage={props.loadPage} />} />
    </Routes>
  </>
);

export default (props: ActionProps & MapProps) => {
  const loadPage = React.useCallback(
    (path: string, qs: GenericMap<string>) => {
      if (path.startsWith("/logout")) {
        window.location.assign(location.pathname);
      } else {
        props.loadPage(path, qs);
      }
    },
    [props.loadPage]
  );

  return (
    <ErrorBoundary hideError={props.hideError}>
      <SpaContainer homePageId={props.homePageId} loadPage={loadPage}>
        {props.isLoading ? null : props.children}
      </SpaContainer>
    </ErrorBoundary>
  );
};
